// import CycleIcon from '@material-ui/icons/Bookmark';

import CycleList from './CycleList';

export default {
    list: CycleList
};
